<template>
  <div class="chart-container">
    <div class="chart-main-container">
      <chart ref="chart" chartType="line" chartId="TrendChart" :width="size === 'mini' ? 300 : 836"
             :height="size === 'mini' ? 180 : 400"></chart>
    </div>
  </div>
</template>

<script lang="js">
import { GraphLineColorSet } from '../../defines/chart-color'
import ChartCmp from './base.vue'

export default {
  name: 'TrendChartCmp',
  components: {
    'chart': ChartCmp
  },
  props: {
    trendComparison: {type: Object, default: () => {}},
    yName: '',
    categoryId: '',
    size: '',
    initialColumnIndex: {type: Number, default: 0}
  },
  data () {
    return {
      selectedColumnIndex: -1,
      selectedTrendResult: null,
      colorSet: GraphLineColorSet
    }
  },
  created () {
    this.selectedColumnIndex = this.initialColumnIndex
    this.$nextTick(() => {
      this.$forceUpdate()
    })
  },
  watch: {
    selectedColumnIndex (newIndex) {
      if (newIndex < 0) return
      this.selectedTrendResult = this.trendComparison.results[newIndex]
    },
    selectedTrendResult (trendResult) {
      if (!trendResult) return

      const ds = trendResult.value.map(value => value.ds)
      const trend = trendResult.value.map(value => value.trend)
      const isMini = this.size === 'mini'

      let datasets = []
      datasets.push(
        Object.assign(
          {
            data: trend,
            type: 'line',
            yAxisID: 'trend',
            fill: false,
            lineTension: 0,
            pointRadius: isMini ? 0 : 3,
            pointBorderWidth: isMini ? 0 : 8
          },
          this.colorSet.red
        )
      )

      const chartData = {
        labels: ds,
        datasets: datasets
      }

      const options = {
        responsive: isMini,
        title: {
          display: false
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              id: 'trend',
              position: 'left',
              type: 'linear',
              scaleLabel: {
                display: true,
                fontSize: 16
              },
              gridLines: {
                drawOnChartArea: false
              },
              ticks: {
                beginAtZero: false
              }
            }
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                fontSize: 16
              },
              ticks: {
                maxRotation: 90
              }
            }
          ]
        }
      }

      this.$refs.chart.renderChart(chartData, options)
    }
  }
}

</script>

<style scoped>
  .chart-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
  }

  .chart-main-container {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/chart/trend.vue